import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { PaymentOrderDto } from '../../../../api/dtos/PaymentOrderDto';
import { ApiClientAdminPaymentOrder } from '../../../../api/endpoints/ApiClientAdminPaymentOrder';
import { OperationService } from '../../operation/operation.service';

@Component({
  standalone: false,
  selector: 'mf-payment-order-edit',
  templateUrl: './payment-order-edit.component.html',
  styleUrls: ['./payment-order-edit.component.scss'],
})
export class PaymentOrderEditComponent {
  constructor(
    private _apiClientAdminPaymentOrder: ApiClientAdminPaymentOrder,
    private _modalService: ModalService,
    private _operationService: OperationService
  ) {
    this.load(this._modalService.openData.paymentOrderId);
  }

  paymentOrderDto: PaymentOrderDto;

  async load(id: string) {
    this.paymentOrderDto = await this._apiClientAdminPaymentOrder.getById(id);
  }

  async save(paymentOrderDto: PaymentOrderDto) {
    paymentOrderDto.id = this.paymentOrderDto.id;
    await this._apiClientAdminPaymentOrder.editDraft(paymentOrderDto);
    this._operationService.reloadOperation(paymentOrderDto.operation.id);
    this._modalService.closeAsSuccess('La orden se editó con éxito');
  }

  close() {
    this._modalService.closeAsSuccess();
  }
}
